module.exports = __webpack_public_path__ + "6d726c431e1e9f9b49bb4144f2746e32.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/Sec-1/bg-en.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/Sec-1/bg-en.jpg
// module chunks = 40